import { useState } from 'react';
import { toast } from 'react-toastify';

import fleetApi from '../../services/api.service';

/**
 * Création manuelle d'un destinataire (POST /addresses)
 */
export default function usePostAddress() {
  const [isLoading, setIsLoading] = useState(false);

  const postAddress = async (addressData) => {
    try {
      setIsLoading(true);
      const response = await fleetApi.post('/addresses', addressData);
      toast.success('Destinataire créé avec succès.');
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, postAddress };
}
